import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import { ArticlesForAutocompleteExpandedQuery } from './__generated__/ArticlesForAutocompleteExpandedQuery';

export const ARTICLES_FOR_AUTOCOMPLETE_EXPANDED_QUERY = gql`
  query ArticlesForAutocompleteExpandedQuery($filter: AllArticlesFilterInput) {
    allArticles(filter: $filter) {
      edges {
        node {
          id
          url
          title
          campaign {
            id
            name
            publisher {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const useArticlesForAutocompleteExpendedLazyQuery = () => {
  return useLazyQuery<ArticlesForAutocompleteExpandedQuery>(ARTICLES_FOR_AUTOCOMPLETE_EXPANDED_QUERY, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
